<div class="popup marginBottomStyle" 
    style="position: relative; overflow: scroll; height: 100%;overflow-x: hidden;">

    <div class="row topRowMargins headerStyle" style="margin-top: 0;"> 
      <div  style="margin-left: 15px;">
        <label class="textColour">SQL Query Builder</label>
      </div>
    </div>
<div class="sql-editor-container">
<app-sql-query-builder [objectList]="data.objectList" [editQuery]="data.Query" [showUnions]="true"  [fromJSIPFormulaBuilder]="data.fromJSIPFormulaBuilder" (parentValueChange)="sqlQueryChange($event)"></app-sql-query-builder>

<!-- <app-test-editor></app-test-editor> -->


  <!-- SQL Query Display -->
  <div class="form-group">
    <label>Generated SQL Query:</label>
    <textarea [(ngModel)]="sqlQuery"></textarea>
  </div>

  <!-- <button class="btn-execute" (click)="executeQuery()">Execute Query</button> -->
</div>

<div  class="row mb-1 topRowMargins" >

  <div class="col-lg text-center" >

      <div style="text-align: end">
        <button
        i18n="@@TMRunButton"
        type="button"
        class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
        [style.background-color]="buttonColor"
        style="padding: .3rem 1.6rem; font-size: .85rem; margin-top: 12px;
          min-width: 150px; white-space: nowrap; flex: 1;position: relative; z-index: 10;
        "
      (click)="proccedFunction()">
        Procced
      </button>
              <button i18n="@@TargetCancel" type="button" (click)="closeFunction()"
              class="cancelButton gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean"
              style="padding: .3rem 1.6rem; font-size: .85rem; margin-top: 12px;
              min-width: 150px; white-space: nowrap; flex: 1;position: relative; z-index: 10;
            " [style.border-color]="backgroundColorButton" >Cancel</button>        


      </div>

  </div>
  
</div>
</div>